<template>
	<div>
		<v-divider></v-divider>
		<div class="pa-2">
			<v-row
				class="mb-2"
				align="center"
				dense>
				<v-spacer></v-spacer>
				<v-divider
					vertical
					class="mx-1"></v-divider>
				<v-col cols="auto">
					<v-btn
						:to="{ name: 'add-interview' }"
						color="primary"
						small>
						<v-icon
							size="20"
							left>
							$add
						</v-icon>
						{{ $T('add') }}
					</v-btn>
				</v-col>
			</v-row>
			<bee-handy-table
				:headers="tableHeaders"
				:items="items"
				:data-table-props="{ disableSort: true }"
				dense
				zebra
				fixed-header
				:height="$vuetify.breakpoint.height - 120"
				hide-default-footer>
				<template v-slot:item.actions>
					<tooltip :text="$T('tooltips.preview')">
						<v-btn
							small
							icon
							@click="
								addDialog = true;
								itemId = 1;
							">
							<v-icon
								size="20"
								color="preview">
								$view
							</v-icon>
						</v-btn>
					</tooltip>
				</template>
			</bee-handy-table>
		</div>

		<!-- add dialog -->
		<v-dialog
			v-model="addDialog"
			max-width="400">
			<v-card>
				<v-form>
					<v-card-title>
						<span>
							{{ `${!itemId ? $T('add') : $T('edit')} ${$T('interviews')}` }}
						</span>
						<v-spacer />
						<v-btn
							icon
							@click="addDialog = false">
							<v-icon>$close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-row dense>
							<v-col cols="12">
								<v-text-field
									v-model="addInterviews.interviewsName"
									:label="$T('inputs.interviewsName')"
									dense
									outlined
									hide-details="auto"></v-text-field>
							</v-col>
							<v-col cols="12">
								<bee-date-picker
									v-model="addInterviews.interviewsDate"
									:input-label="$T('inputs.interviewsDate')"
									outlined
									menu-picker
									:input-props="{
										outlined: true,
										dense: true,
										prependInnerIcon: '$calendar',
									}"
									no-title
									dense
									hide-details></bee-date-picker>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn
							color="secondary"
							@click="addDialog = false">
							{{ $T('default-buttons.save') }}
						</v-btn>
					</v-card-actions>
				</v-form>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import moment, { DATE_FORMAT } from '@/utils/moment';

export default {
	name: 'EmployeeInterviews',

	data() {
		return {
			itemId: null,

			addDialog: false,

			searchName: null,
			searchSection: null,
			searchType: null,

			searchDate: new Date().toISOString().slice(0, 7),

			addInterviews: {
				name: null,
				section: null,
				interviewsName: null,
				interviewsDate: null,
			},

			tableHeaders: [
				{
					text: this.$T('headers.section-name'),
					name: 'section',
					value: 'section',
				},
				{
					text: this.$T('headers.interviewsName'),
					name: 'interviewsName',
					value: 'interviewsName',
				},
				{
					text: this.$T('headers.interviewsDate'),
					name: 'interviewsDate',
					value: 'interviewsDate',
					type: 'date',
					dateFormat: DATE_FORMAT,
				},
				{
					text: this.$T('headers.interviewsResult'),
					name: 'interviewsResult',
					value: 'interviewsResult',
				},
				{ text: '', name: 'actions', value: 'actions', width: 20 },
			],

			//! to delete
			items: [
				{
					section: 'قسم المعلوماتية',
					interviewsName: 'تقييم دوري',
					interviewsDate: new Date(),
					interviewsResult: '9/10',
				},
				{
					section: 'قسم المعلوماتية',
					interviewsName: 'استبيان رضا الزبون',
					interviewsDate: new Date(),
					interviewsResult: '7.5/10',
				},
				{
					section: 'الخياطة',
					interviewsName: 'تقيم سنوي',
					interviewsDate: new Date(),
					interviewsResult: '8/10',
				},
			],
			employees: [
				{ code: '10-191', name: 'محمد الاحمد', section: 'قسم الميكانيك' },
				{ code: '25-252', name: 'امجد درعوزي', section: 'قسم المعلوماتية' },
				{ code: '23-343', name: 'علي اغا', section: 'قسم الخياطة' },
				{ code: '10-1911', name: 'محمد الاحمد', section: 'قسم الميكانيك' },
				{ code: '25-2521', name: 'امجد درعوزي', section: 'قسم المعلوماتية' },
				{ code: '23-3431', name: 'علي اغا', section: 'قسم الخياطة' },
				{ code: '10-1912', name: 'محمد الاحمد', section: 'قسم الميكانيك' },
				{ code: '25-2522', name: 'امجد درعوزي', section: 'قسم المعلوماتية' },
				{ code: '23-3432', name: 'علي اغا', section: 'قسم الخياطة' },
			],
			sections: ['قسم الميكانيك', 'قسم المعلوماتية', 'قسم الخياطة'],
		};
	},

	methods: {
		clearFilters() {
			this.searchName = null;
			this.searchSection = null;
		},
		moment,
	},
};
</script>

<style lang="scss" scoped></style>
